import jwtDecode from "jwt-decode";
import Moment from "moment";

const getJWT = () => localStorage.getItem("idToken");

const decodeJWT = () => {
  const token = getJWT();
  if (!token) return null;
  return jwtDecode(token);
};

const tokenIsExpired = () => {
  const decoded = decodeJWT();
  if (!decoded || !decoded.exp) return true;

  const currentTimeEpoch = Moment().unix();
  return currentTimeEpoch > decoded.exp;
};

export { decodeJWT, tokenIsExpired };
